import React, { useContext, useEffect, useRef } from "react";
import { ProduitIngredientListe, ProduitInterface } from "dataProvider/Produit";
import { IntlContext } from "context";
import { Link } from "react-router-dom";

export interface IngredientsProps {
    produit: ProduitInterface | any;
    more: {
        visible?: boolean;
        onClick?: (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    };
}

const Ingredients: React.FC<IngredientsProps> = ({ produit, more = { visible: false } }) => {
    const intl = useContext(IntlContext);
    const otherKey = "others";
    const refInfo = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        if (refInfo.current && refInfo.current.offsetHeight >= refInfo.current.scrollHeight) {
            more?.onClick && more.onClick();
        }
    }, [more]);

    if (!(produit?.produit_ingredient_listes || []).length || !(produit?.produit_ingredients || []).length) {
        return null;
    }

    const ingListes: string[] = (produit?.produit_ingredient_listes || []).reduce(
        (memo: string[], pil: ProduitIngredientListe) => {
            const liste = pil?.ingredient_liste;
            if (liste) {
                memo.push(liste);
            }
            return memo;
        },
        []
    );

    const ingredients = (produit?.produit_ingredients || []).reduce(
        (memo: HashMap<string[]>, ingredient: any) => {
            let value: string[] = [];
            let unitMesureId = "" + ingredient?.id_unitemesure_ingredient;
            let unitMesure = ingredient?.unitemesure_ingredient_libel;
            let unitExp = ingredient?.uniteexpression_libel;
            let quantite = ingredient?.quantite;
            let libel = ingredient?.ingredient_libel;

            switch (unitMesureId) {
                case "25": //Traces
                    break;
                case "26": //Contient
                    break;
                default:
                    unitMesureId = unitMesureId.length ? otherKey : unitMesureId;
                    break;
            }

            if (unitMesureId && libel) {
                if (!memo[unitMesureId]) {
                    memo[unitMesureId] = [];
                }

                value.push(libel);

                if (quantite !== undefined && quantite !== null) {
                    value.push(`${quantite}${unitMesure || ""}`);

                    if (unitExp && unitExp !== "_") {
                        value.push(unitExp);
                    }
                }

                memo[unitMesureId].push(value.join(" "));
            }

            return memo;
        },
        { otherKey: ingListes }
    );

    const renderIngredients = (ingredients: HashMap<string[]>) => {
        const groups: string[] = [];
        // Others
        if (ingredients[otherKey]?.length) {
            groups.push(ingredients[otherKey].join(", "));
        }
        // Traces
        if (ingredients["25"]?.length) {
            groups.push(`${intl.formatMessage("produit.fiche.label.traces")} : ${ingredients["25"].join(", ")}`);
        }
        // Contient
        if (ingredients["26"]?.length) {
            groups.push(`${intl.formatMessage("produit.fiche.label.contient")} : ${ingredients["26"].join(", ")}`);
        }
        return <React.Fragment>{groups.join(". ")}.</React.Fragment>;
    };

    const getIngredientSource = (ingredients: HashMap<any>[]): string => {
        const sources: string[] = ingredients.reduce((memo: string[], ingredient: any) => {
            if (!memo.includes(ingredient?.source_libel)) {
                memo.push(ingredient?.source_libel);
            }
            return memo;
        }, []);
        return sources.join(", ");
    };
    const ingredientSource = getIngredientSource(produit?.produit_ingredients || []);

    return (
        <div className="product-informations__block">
            <h2 className="information__title">{intl.formatMessage("produit.fiche.label.ingredients")}</h2>

            <p
                ref={refInfo}
                className={`information-list-ingredients ${more.visible ? "information-list-ingredients--all" : ""}`}
            >
                {renderIngredients(ingredients)}
                <span className="align-right display-block">
                    <br />
                    {intl.formatMessage("produit.fiche.label.source")} :{" "}
                    {ingListes.length
                        ? ingredientSource
                        : intl.formatMessage("produit.fiche.label.ingredients_reconstitution")}
                </span>
            </p>

            <div className={`information-list-ingredients-more ${more.visible ? "hidden" : ""}`}>
                <Link
                    to="#"
                    className="cta cta--link cta-ingredients-more"
                    title={intl.formatMessage("generic.see_all")}
                    onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        more?.onClick && more.onClick(e);
                    }}
                >
                    {intl.formatMessage("generic.see_all")}
                </Link>
            </div>
        </div>
    );
};

export default Ingredients;
